import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "d-flex flex-column align-items-center justify-content-center p-4" }
const _hoisted_4 = { class: "font-weight-600 p-3" }
const _hoisted_5 = { class: "font-big mb-4 font-weight-400 form-sub-title" }
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "d-flex flex-column w-100" }
const _hoisted_8 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!
  const _component_VueGoogleAutocomplete = _resolveComponent("VueGoogleAutocomplete")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CheckBoxComponent, {
      id: _ctx.id,
      class: "me-3",
      "data-bs-toggle": !_ctx.isChecked ? 'modal' : '',
      "data-bs-target": `#${_ctx.id}-modal`,
      state: _ctx.isChecked,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setChecked($event)))
    }, null, 8, ["id", "data-bs-toggle", "data-bs-target", "state"]),
    _createElementVNode("label", {
      for: _ctx.id,
      class: "additional-info-label-text"
    }, _toDisplayString(_ctx.labelText) + " " + _toDisplayString((_ctx.address.length > 0) ? `(${_ctx.address})` : ''), 9, _hoisted_2),
    _createVNode(_component_ModalComponent, {
      "show-title": false,
      "id-data": `${_ctx.id}-modal`
    }, {
      "body-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.upperText), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.lowerText), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_VueGoogleAutocomplete, {
                classname: "form-control",
                country: "lt",
                types: "",
                ref: "address",
                placeholder: _ctx.$t('address'),
                id: `${_ctx.id}-input`,
                onPlacechanged: _ctx.setAddressData
              }, null, 8, ["placeholder", "id", "onPlacechanged"]),
              _withDirectives(_createElementVNode("textarea", {
                placeholder: _ctx.$t('comment'),
                class: "form-text-area-input mb-4",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.note) = $event))
              }, null, 8, _hoisted_8), [
                [_vModelText, _ctx.note]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["id-data"])
  ]))
}